import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
/**
 * Step 0 — Validates the invitation token before showing the wizard.
 * Checks: exists, status === 'pending', not expired.
 * If the invitation has an assessment_id, also fetches the assessment so the
 * wizard can pre-populate the personal and dog details steps.
 */
export default function TokenGate({ token, onValid }) {
    const [error, setError] = useState(null);
    const [checking, setChecking] = useState(true);
    useEffect(() => {
        async function validate() {
            const { data } = await supabase
                .from('invitations')
                .select('*')
                .eq('token', token)
                .limit(1);
            if (!data || data.length === 0) {
                setError('This invitation link is invalid.');
                setChecking(false);
                return;
            }
            const invite = data[0];
            if (invite.status === 'accepted') {
                setError('This invitation has already been used. Please log in instead.');
                setChecking(false);
                return;
            }
            if (invite.status === 'expired' || new Date(invite.expires_at) < new Date()) {
                setError('This invitation link has expired. Please ask us to send a new one.');
                setChecking(false);
                return;
            }
            // Fetch assessment if linked
            let assessment = null;
            if (invite.assessment_id) {
                const { data: assessData } = await supabase
                    .from('assessments')
                    .select('*')
                    .eq('id', invite.assessment_id)
                    .single();
                assessment = assessData ?? null;
            }
            setChecking(false);
            onValid(invite, assessment);
        }
        validate();
    }, [token, onValid]);
    if (checking) {
        return (_jsxs("div", { className: "bg-white rounded-2xl border border-gray-200 w-full max-w-sm shadow-sm overflow-hidden text-center", children: [_jsx("div", { style: { backgroundColor: '#444444' }, children: _jsx("img", { src: "/images/logo-v3.webp", alt: "Springfield Dog Centre", className: "w-full" }) }), _jsx("div", { className: "p-8", children: _jsx("p", { className: "text-sm text-brand-body", children: "Checking your invitation\u2026" }) })] }));
    }
    if (error) {
        return (_jsxs("div", { className: "bg-white rounded-2xl border border-gray-200 w-full max-w-sm shadow-sm overflow-hidden text-center", children: [_jsx("div", { style: { backgroundColor: '#444444' }, children: _jsx("img", { src: "/images/logo-v3.webp", alt: "Springfield Dog Centre", className: "w-full" }) }), _jsxs("div", { className: "p-8", children: [_jsx("h2", { className: "text-xl font-bold text-brand-ink mb-2", children: "Invalid invitation" }), _jsx("p", { className: "text-sm text-brand-body mb-6", children: error }), _jsx("a", { href: "/login", className: "text-sm text-brand-green hover:underline", children: "Go to login \u2192" })] })] }));
    }
    return null;
}
